class TabElement {
  constructor(element, ...options) {
    this.defaults = {
      tabNavSelector: '.js-tab-nav',
      tabContentSelector: '.js-tab-content',
      sliderOptions: {
        mode: 'gallery',
        controls: false,
        autoplay: false,
        nested: 'outer',
        touch: false
      },
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.tabNav = this.element.querySelector(this.options.tabNavSelector);
    this.tabContent = this.element.querySelector(this.options.tabContentSelector);

    this.tabSlider = new TinySlider(this.tabContent, Object.assign({}, this.options.sliderOptions, {
      navContainer: this.tabNav,
    }));
  }
}
